import { AsyncPipe, CurrencyPipe, DatePipe, DOCUMENT, NgClass, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, inject, OnChanges, OnInit, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, Params, RouterLink } from '@angular/router';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';
import { InfoPagamentoComponent } from 'app/modules/shared/info-pagamento/info-pagamento.component';
import { ElenchiService } from 'app/services/elenchi.service';
import { Istanza, IstanzeService } from 'app/services/istanze.service';
import { PagopaService, Pagamento } from 'app/services/pagopa.service';
import { filter, map, Observable, of, switchMap, take, tap } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from 'app/modules/shared/snackbar.component';
import {MatExpansionModule} from '@angular/material/expansion';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';


@Component({
    selector: 'pago-pa',
    templateUrl: './pagopa.type.html',
    styleUrls: ['./pagopa.type.scss'],
    standalone: true,
    imports: [FormlyModule, RouterLink, MatIconModule, MatButtonModule, MatExpansionModule,NgIf, MatFormFieldModule, MatBadgeModule, MatProgressSpinnerModule, CurrencyPipe, AsyncPipe, DatePipe, NgTemplateOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: MAT_DIALOG_DATA, useValue: {} },
        { provide: MatDialogRef, useValue: {} }
    ]
})
export class PagoPaComponent extends FieldWrapper implements OnInit {


    emailIstanza: SafeUrl;


    constructor(
        private route: ActivatedRoute,
        private _pagopaService: PagopaService,
        private _istanzeService: IstanzeService,
        private _elenchiService: ElenchiService,
        private _matDialog: MatDialog,
        private _snackBar: MatSnackBar,
        private sanitizer: DomSanitizer,
        private _changeDetectorRef: ChangeDetectorRef) {
        super()
    }



    private _document: Document = inject(DOCUMENT);

    pagamenti: Pagamento[];
    pagamenti$: Observable<Pagamento[]>
    numeroPagamenti: number = 0;
    statoIstanza: string;
    istanza$: Observable<any>
    showDettagli:boolean = false

    document_id: string;
    codice: string;

    dettagliVisibili: { [key: string]: boolean } = {};


    ngOnInit(): void {


        this.emailIstanza = this.sanitizer.bypassSecurityTrustUrl('mailto:assistenza@istanze-online.it');
        //console.log(this.options.formState.cmp);

        this.pagamenti$ = this._pagopaService.pagamenti$;

        this._istanzeService.istanza$.subscribe((data) => {
            this.codice = data.codice;
            this.document_id = data.id;
        })



        this.route.queryParams.pipe(
            filter((params) => params["pagopa"] == "ok"),
        ).subscribe()


        // this._pagopaService.pagamenti$.subscribe(
        //     (pagamenti)=>    {
        //         this.pagamenti = pagamenti
        //         this.numeroPagamenti = pagamenti.length

        //         this.pagamenti = pagamenti.filter((pagamento) => pagamento.stato === 'null')
        //     }

        // )




    }

    //   ngOnChanges(changes: SimpleChanges): void {

    //     if (changes['pagamenti']) {
    //         this._change.markForCheck();
    //     }

    //   }

    openSnackBar(messaggio: string, duration = 1000, error: string = '') {
        this._snackBar.openFromComponent(SnackBarComponent, {
            duration: duration,
            data: {
                messaggio: messaggio,
                error: error
            },
            panelClass: ['mat-toolbar', 'mat-primary'],
            horizontalPosition: 'center',
            verticalPosition: 'bottom'
        });
    }

    pagaOnline(pagamento_id: string) {
        this._pagopaService.pagamentoOnline(pagamento_id).subscribe(
            redirect_url => {
                if (redirect_url){
                    window.location.href = redirect_url
                }
                else{
                    this.openSnackBar("Errore nella gestione del pagamento", 1000, 'dddddddddddddddddddd')
                }
            }
        )
    }

    pagaAvviso(pagamento_id: string) {
        this._pagopaService.pagamentoAvviso(pagamento_id).subscribe(
            result => {
                console.log(result)
                if (result["iuv"] != undefined) {
                    this.openSnackBar("Avviso di pagamento creato correttamente", 3000)
                }
                else if (result["esito"] == "ERROR") {
                    this.openSnackBar(result["errore"], 1000, 'dddddddddddddddddddd')
                }
                else {
                    console.log(result)
                }
            }
        )
    }

    annullaAvviso(pagamento_id: string) {

        this._pagopaService.annullaAvvisoPagamento(pagamento_id).subscribe(
            result => {
                if (result["id"] != undefined) {
                    this.openSnackBar("Avviso di pagamento annullato", 3000)
                }
                else if (result["esito"] == "ERROR") {
                    this.openSnackBar(result["errore"], 1000, 'dddddddddddddddddddd')
                }
                else {
                    console.log(result)
                }
            }
        )

    }

    scaricaAvviso(pagamento: Pagamento) {

        this._pagopaService.getAvvisoPagamento(pagamento.id).subscribe((response: any) => {
            const fileName = `avviso-${pagamento.idpos}.pdf`;
            if ((window.navigator as any).msSaveBlob) {
                (window.navigator as any).msSaveBlob(response, fileName);
            } else {
                let dataType = response.type;
                let binaryData = [];
                binaryData.push(response);
                let downloadLink = document.createElement('a');
                downloadLink.href = window.URL.createObjectURL(
                    new Blob(binaryData, { type: dataType })
                );
                downloadLink.setAttribute('download', fileName);
                document.body.appendChild(downloadLink);
                downloadLink.click();
            }
        });

    }

    scaricaRicevutaPagamento(pagamento: Pagamento) {

        console.log("DA FARE")

        this.pagamenti$.subscribe(
            (x) => console.log(x)
        )



    }


    eliminaOK(pagamento: Pagamento) {
        return ((new Date().getTime() - new Date(pagamento.data_inserimento).getTime()) / 1000) / 60 > 1 //10
    }

    infoPagamento(pagamento_id: string) {

        this._pagopaService.getInfoPagamento(pagamento_id).subscribe(
            result => {
                console.log(result)

                // Open the dialog
                const dialogRef = this._matDialog.open(InfoPagamentoComponent, {
                    autoFocus: false,
                    data: result
                });

                dialogRef.afterClosed().subscribe((result) => {
                    console.log('Compose dialog was closed!');
                });

            }
        )

    }


    toggleImporti(pagamentoId: string): void {
        if (!this.dettagliVisibili) {
          this.dettagliVisibili = {};
        }
        this.dettagliVisibili[pagamentoId] = !this.dettagliVisibili[pagamentoId];
      }



    zeroPad = (num: number, places: number) => String(num).padStart(places, '0')


    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(item: Pagamento): string {
        return item.id;
    }



    private _scrollElementIntoView(): void {


        // Wrap everything into setTimeout so we can make sure that the 'current-step' class points to correct element
        setTimeout(() => {
            // Get the current step element and scroll it into view
            const currentStepElement = this._document.getElementsByClassName('pagamento_top')[0];
            if (currentStepElement) {
                currentStepElement.scrollIntoView({
                    behavior: 'auto',
                    block: 'start',
                    inline: 'nearest'
                });
            }
        });
    }


    getStatoPagamento(value: string) {
        return this._elenchiService.getOptionLabel('tipo_stato_pagamento', value);
    }

}



